module.exports = __webpack_public_path__ + "img/violet-6.b4b994d6.png";